<template>
  <div class="container mx-auto max-w-screen-2xl px-6 sm:px-8 lg:px-16"><slot></slot></div>
</template>
